"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAppInstallability = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _immutable = _interopRequireDefault(require("immutable"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var AppUninstallableReasons = _interopRequireWildcard(require("../../constants/installability/AppUninstallableReasons"));

var _AppInstallability = _interopRequireDefault(require("../../records/AppInstallability"));

var useAppInstallability = function useAppInstallability(_ref) {
  var installability = _ref.installability,
      offeringId = _ref.offeringId,
      _ref$apiBase = _ref.apiBase,
      apiBase = _ref$apiBase === void 0 ? 'ecosystem/v1' : _ref$apiBase,
      onFetchAppInstallabilityError = _ref.onFetchAppInstallabilityError;

  var _useState = (0, _react.useState)(installability),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      appInstallability = _useState2[0],
      setInstallability = _useState2[1];

  (0, _invariant.default)(installability || offeringId, 'useAppInstallability hook expects either an AppInstallability instance or an offeringId');
  (0, _invariant.default)(!installability || installability instanceof _AppInstallability.default, 'installability must be an AppInstallability record');
  (0, _react.useEffect)(function () {
    if (!installability) {
      _apiClient.default.get(apiBase + "/offerings/" + offeringId + "/installability").then(function (resp) {
        return setInstallability(new _AppInstallability.default(resp));
      }).catch(function (err) {
        if (typeof onFetchAppInstallabilityError === 'function') {
          onFetchAppInstallabilityError(err);
        } else {
          throw err;
        }
      });
    }
  }, [installability, offeringId, apiBase, onFetchAppInstallabilityError]);
  var result = (0, _react.useMemo)(function () {
    if (!appInstallability) {
      return {};
    }

    var installed = appInstallability.installed,
        incompatibleHubInstalls = appInstallability.incompatibleHubInstalls,
        incompatibleHubUserInstalls = appInstallability.incompatibleHubUserInstalls,
        missingHubUserRoles = appInstallability.missingHubUserRoles,
        missingHubScopes = appInstallability.missingHubScopes,
        missingHubScopeGroups = appInstallability.missingHubScopeGroups;
    var isAppInstallable = false;
    var appUninstallableReason = null;

    var appInstallabilityExtras = _immutable.default.Set();

    if (installed) {
      appUninstallableReason = AppUninstallableReasons.ALREADY_INSTALLED;
    } else if (missingHubUserRoles.size && !missingHubScopes.size) {
      appUninstallableReason = AppUninstallableReasons.MISSING_USER_PERMISSIONS;
      appInstallabilityExtras = missingHubUserRoles;
    } else if (missingHubScopes.size || missingHubScopeGroups.size) {
      appUninstallableReason = AppUninstallableReasons.MISSING_HUB_SCOPES;
      var missingScopes = missingHubScopes.size ? missingHubScopes : missingHubScopeGroups;
      appInstallabilityExtras = missingScopes;
    } else if (incompatibleHubInstalls.size || incompatibleHubUserInstalls.size) {
      appUninstallableReason = AppUninstallableReasons.INCOMPATIBLE_INSTALLS;
      var incompatibleInstalls = incompatibleHubInstalls.size ? incompatibleHubInstalls : incompatibleHubUserInstalls;
      appInstallabilityExtras = incompatibleInstalls;
    } else {
      isAppInstallable = true;
    }

    return {
      isAppInstallable: isAppInstallable,
      appUninstallableReason: appUninstallableReason,
      appInstallabilityExtras: appInstallabilityExtras
    };
  }, [appInstallability]);
  return result;
};

exports.useAppInstallability = useAppInstallability;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/utils/hooks/useAppInstallability.js
// module id = 796
// module chunks = 209 210 211 212